import { motion } from "framer-motion";
import { Flag, ArrowUpRight } from "lucide-react";
import { PHOTOS } from "./assets";

const LEVELS = ["Youth Athletes", "Middle School", "High School", "College Athletes"];

export default function Camps() {
  const scrollTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="camps"
      data-testid="camps-section"
      className="relative py-24 md:py-36 bg-black border-t border-white/10 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={PHOTOS.youth}
          alt="Camp training"
          loading="lazy"
          className="w-full h-full object-cover object-[center_35%] grayscale opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <Flag size={18} className="text-white/70" />
            <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40">
              Events
            </p>
          </div>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            Camps & Clinics
          </h2>
          <p className="mt-6 text-white/65 text-lg leading-relaxed max-w-2xl">
            Elite training experiences hosted throughout Ohio, West Virginia,
            Virginia, and surrounding areas. Travel opportunities, team training,
            and special events are available.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {LEVELS.map((l) => (
              <span
                key={l}
                className="font-mono-accent text-[11px] tracking-[0.2em] uppercase text-white/70 border border-white/20 px-4 py-2"
              >
                {l}
              </span>
            ))}
          </div>

          <button
            data-testid="camps-cta"
            onClick={() => scrollTo("#contact")}
            className="mt-10 inline-flex items-center gap-2 bg-white text-black uppercase tracking-[0.2em] font-bold text-sm px-10 py-5 hover:bg-white/85 transition-colors duration-300"
          >
            Request a Camp or Clinic <ArrowUpRight size={18} />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
